module.exports = __webpack_public_path__ + "static/media/brokenPage.52b6187d.png";